import React from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import style from "./SubmitBidModal.module.scss";
import CustomButton from "../../../../custom/custom-button/CustomButton";
import CloseIconNew from "../../../../shared/icons/CloseIconNew";

const SubmitBidModal = ({ isOpen, assignmentMethod, onClose, onConfirm, isLoading = false, isDisabled = false }) => {
  const { t } = useTranslation();
  const isAuction = assignmentMethod === "Auction";
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={style.overlay} onClick={onClose} data-portal-modal="true">
      <div className={style.modal} onClick={(e) => e.stopPropagation()}>
        <button className={style.close_btn} onClick={onClose} aria-label={t("orderInfoExpeditor.assignDriverModal.close")}>
          <CloseIconNew width="24" height="24" fill="#212121" />
        </button>
        <div className={style.body}>
          <p className={style.title}>{t("orderInfoExpeditor.suggestPrice.submitTitle")}</p>
          <p className={style.description}>
            {t(
              isAuction
                ? "orderInfoExpeditor.suggestPrice.auctionSubmitDescription"
                : "orderInfoExpeditor.suggestPrice.submitDescription",
            )}
          </p>
        </div>
        <div className={style.footer}>
          <div className={style.footer_btn}>
            <CustomButton
              text={t("orderInfoExpeditor.suggestPrice.no")}
              isNavy
              isWhite
              onClick={onClose}
              disabled={isLoading}
              style={{ width: "100%" }}
            />
          </div>
          <div className={style.footer_btn}>
            <CustomButton
              text={t("orderInfoExpeditor.suggestPrice.yes")}
              isNavy
              onClick={onConfirm}
              isLoading={isLoading}
              disabled={isLoading || isDisabled}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SubmitBidModal;
